import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert from '@mui/material/Alert'
import { useDispatch, useSelector } from 'react-redux'
import { closeNotification } from '../actions/notificationAction'

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert ref={ref} elevation={6} variant="filled" {...props} />
})

const NotifyInfo = () => {
  const dispatch = useDispatch()
  const notification = useSelector((state) => state.notifications)

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return
    dispatch(closeNotification())
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={Boolean(notification?.open)}
      autoHideDuration={notification?.duration ?? 3000}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={notification?.notificationType ?? 'info'}
      >
        {notification?.message ?? ''}
      </Alert>
    </Snackbar>
  )
}

export default NotifyInfo